<template>
    <!--分页组件-->
    <div class="pageComponent" v-if="pageConfig.total">
        <!--上一页
        <button @click="prePage" :disabled="currentPage === 1" class="pt10 pb10 pl12 pr12" :class="[currentPage == 1?'':'b1']">&lt;</button>
        -->
        <!--总页数小于8的-->
        <template v-if="pageTotal <= showPageNo">
          <button v-for="i in pageTotal" @click="changeCurrentPage(i)" :class="[i === currentPage?'bg-color-primary color-white b1':'b1']"  :key="i" class="pt10 pb10 pl12 pr12 mr4 r5">{{i}}</button>
        </template>
        <template v-else-if="currentPage < 5">
          <button v-for="i in 5" @click="changeCurrentPage(i)" :class="[i === currentPage?'bg-color-primary color-white b1':'b1']" :key="i" class="pt10 pb10 pl12 pr12 mr4 r5">{{i}}</button><button @click="changeCurrentPage(pageTotal)" class="pt10 pb10 pl12 pr12 mr4 r5 b1">...{{pageTotal}}</button>
        </template>
        <template v-else-if="currentPage > pageTotal - 5">
          <button @click="changeCurrentPage(1)" class="pt10 pb10 pl12 pr12 mr4 r5 b1">1..</button><button v-for="i in 5" @click="changeCurrentPage(i + (pageTotal - 5))" :class="[(i + (pageTotal - 5)) === currentPage?'bg-color-primary color-white b1':'b1']"  :key="i" class="pt10 pb10 pl12 pr12 mr4 r5">{{i + (pageTotal - 5)}}</button>
        </template>
        <template v-else>
         <button @click="changeCurrentPage(1)" class="pt10 pb10 pl12 pr12 mr4 r5 b1">1..</button><button @click="changeCurrentPage(currentPage - 1)" class="pt10 pb10 pl12 pr12 mr4 r5 b1">{{currentPage - 1}}</button><button class="pt10 pb10 pl12 pr12 mr4 r5 bg-color-primary color-white b1">{{currentPage}}</button><button @click="changeCurrentPage(currentPage + 1)" class="pt10 pb10 pl12 pr12 mr4 r5 b1">{{currentPage + 1}}</button><button @click="changeCurrentPage(currentPage + 2)" class="pt10 pb10 pl12 pr12 mr4 r5 b1">{{currentPage + 2}}</button><button @click="changeCurrentPage(pageTotal)" class="pt10 pb10 pl12 pr12 mr4 r5 b1">..{{pageTotal}}</button>
        </template>
        <!--下一页
        <button @click="nextPage" class="pt10 pb10 pl12 pr12" :disabled="currentPage === pageTotal" :class="[currentPage === pageTotal?'':'b1']">></button>
        -->
      </div>
  </template>
  
  <script>
    export default {
      name: "pageComponent",
      props: {
        // 分页配置
        pageConfig: {
          type: Object, require: true, default() {
            return {
              pageSize: 10,     //一页的数据条数
              pageNo: 0,        //当前页的索引
              total: 0,         //总的数据条数
              pageTotal: 0      //总的页数
            }
          }
        }
      },
      data() {
        return {
          //默认显示
          showPageNo:8,
          currentPage:0
        }
      },
      methods: {
        prePage(){
          this.currentPage -= 1
          this.$emit('changeCurrentPage',this.currentPage)
        },
        nextPage(){
          this.currentPage += 1
          this.$emit('changeCurrentPage',this.currentPage)
        },
        changeCurrentPage(i){
          this.currentPage = i
          this.$emit('changeCurrentPage',this.currentPage)
        }
      },
      computed: {
        //计算总页数，如果传了pageTotal,直接取pageTotal的值，如果传了total，那么根据pageSize去计算
        pageTotal(){
          this.currentPage = this.$store.state.app_args.product_page
          const config = this.pageConfig
          if(config.pageTotal){
            return config.pageTotal
          }else {
            if(config.pageSize && config.total){
              return Math.ceil(config.total/config.pageSize)
            }else {
              return 0
            }
          }
        }
      },
      created: function () {
        this.currentPage = this.$store.state.app_args.product_page
      }
    }
  </script>


// WEBPACK FOOTER //
// src/components/pageComponent.vue